export var BASE = '';
export var SERVICE_ROOT = '/wsvc';
export var MOBILE_V1 = "".concat(SERVICE_ROOT, "/mobile/v1");
export var OLD_PUBLIC = "".concat(BASE, "/ah");